var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12634_37892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.1276C8 9.61281 8.18019 9.1881 8.54054 8.85349C8.9009 8.51887 9.36937 8.35156 9.94595 8.35156C10.5122 8.35156 10.9704 8.51629 11.3205 8.84577C11.6808 9.18554 11.861 9.62826 11.861 10.174C11.861 10.6682 11.686 11.08 11.3359 11.4095C10.9756 11.7492 10.5019 11.9191 9.91506 11.9191H9.89961C9.33333 11.9191 8.87517 11.7492 8.5251 11.4095C8.17503 11.0697 8 10.6424 8 10.1276ZM8.20077 23.6411V13.3245H11.6293V23.6411H8.20077ZM13.529 23.6411H16.9575V17.8805C16.9575 17.5202 16.9987 17.2422 17.0811 17.0465C17.2252 16.6965 17.444 16.4005 17.7375 16.1585C18.0309 15.9166 18.399 15.7956 18.8417 15.7956C19.9949 15.7956 20.5714 16.5729 20.5714 18.1276V23.6411H24V17.7261C24 16.2023 23.6396 15.0465 22.9189 14.2589C22.1982 13.4713 21.2458 13.0774 20.0618 13.0774C18.7336 13.0774 17.6988 13.6489 16.9575 14.7917V14.8226H16.9421L16.9575 14.7917V13.3245H13.529C13.5495 13.654 13.5598 14.6785 13.5598 16.3979C13.5598 18.1173 13.5495 20.5317 13.529 23.6411Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12634_37892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.2896,
    fill: "white",
    transform: "translate(8 8.35156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.c199303d910a6041562a6adb5920e689.svg";
export { ForwardRef as ReactComponent };